export enum PartyStatusTypes {
  Active = 0,
  Closed = 2,
}
